import { Component, OnInit } from '@angular/core';
import { IdbService } from 'app/services/idb.service';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css']
})
export class LoginComponent implements OnInit {
// notes: https://developers.google.com/identity/protocols/oauth2/javascript-implicit-flow#oauth-20-endpoints_5

  CLIENT_ID:string ='966702354234-po6gblj1p2vnbpft7iesc2emmr2dnlf2.apps.googleusercontent.com';
  REDIRECT_URI:string ='http://localhost:4200/sessions/loading'
  constructor(private idb : IdbService) { }

  ngOnInit() {
    var fragmentString = location.hash.substring(1);

   // Parse query string to see if page request is coming from OAuth 2.0 server.
   var params = {};
   var regex = /([^&=]+)=([^&]*)/g, m;
   while (m = regex.exec(fragmentString)) {
     params[decodeURIComponent(m[1])] = decodeURIComponent(m[2]);
   }
   if (Object.keys(params).length > 0) {
     localStorage.setItem('oauth2-test-params', JSON.stringify(params) );
     if (params['state'] && params['state'] == 'dash_login') {
      console.log("Nope.  Not from google!")
       this.idb.clearData('jobs').then(obj=>console.log('cleared jobs list',obj));
     }
   }

  }

    /*
   * Create form to request access token from Google's OAuth 2.0 server.
   */
 oauth2SignIn() {
    // Google's OAuth 2.0 endpoint for requesting an access token
    var oauth2Endpoint = 'https://accounts.google.com/o/oauth2/v2/auth';

    // Create element to open OAuth 2.0 endpoint in new window.
    var form = document.createElement('form');
    form.setAttribute('method', 'GET'); // Send as a GET request.
    form.setAttribute('action', oauth2Endpoint);
// sample scope: https://www.googleapis.com/auth/drive.metadata.readonly,
    // Parameters to pass to OAuth 2.0 endpoint.
    var params = {'client_id': this.CLIENT_ID,
                  'redirect_uri': this.REDIRECT_URI,
                  'scope':'openid email profile',
                  'state': 'dash_login',
                  'include_granted_scopes': 'true',
                  'response_type': 'token',
                  'hd':'pinnaclepowersvcs.com'
                };

    // Add form parameters as hidden input values.
    for (var p in params) {
      var input = document.createElement('input');
      input.setAttribute('type', 'hidden');
      input.setAttribute('name', p);
      input.setAttribute('value', params[p]);
      form.appendChild(input);
    }

    // Add form to page and submit it to open the OAuth 2.0 endpoint.
    document.body.appendChild(form);
    form.submit();
  }
 


}
